import styled from "@theme/utils";
export const LogoImg = styled.div`
    padding: 10px 0;
`;
